module.exports = __webpack_public_path__ + "static/media/dicoding.4cf5740a.png";